
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Order, OrderStatus, OrderDetail } from "../../viewmodels/Order";
import { CategoryType } from "../../viewmodels/Category";

@Component({})
export default class extends Vue {
  public collection = app.orderCollection;

  public search: string = "";
  public model: Order = new Order({}, this.collection);

  public dialog = false;
  public formTitle: string = "Restaurant";

  public headers = [
    { text: "Id", value: "id" },
    { text: "Customer", value: "customer_name" },
    { text: "Table", value: "table_name" },
    { text: "Status", value: "status" },
    { text: "Actions", value: "" }
  ];

  public subHeaders = [
    { text: "Id", value: "product_id" },
    { text: "Name", value: "product_name" },
    { text: "Quantity", value: "quantity" },
    { text: "Size", value: "product_size" }
  ];

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public close() {
    this.dialog = false;
  }

  public filterOnlyOrdersWithFood(items: Order[]) {
    return items.filter(
      order =>
        order.status === OrderStatus.Ordered &&
        order.details &&
        order.details.some(
          (detail: OrderDetail) => detail.category_type === CategoryType.Food
        )
    );
  }

  public filterOnlyFood(items: OrderDetail[]) {
    return items.filter(detail => detail.category_type === CategoryType.Food);
  }

  public async markAsReady(item: Order) {
    this.model = item;
    try {
      const dialog: any = (this.$root as any).$confirm;
      dialog(
        "Order Status Change",
        "This order's status will be changed?"
      ).then(async (confirm: boolean) => {
        if (confirm) {
          await this.model.changeOrderItemsStatus(
            OrderStatus.ReadyForDelivery,
            this.filterOnlyFood(item.details).map(x => x.id)
          );
          this.dialog = false;
          this.$store.dispatch("showSnackbar", {
            message: "Order status changed to 'ready for delivery' succesfully!"
          });
        }
      });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }
}
